module.exports = __webpack_public_path__ + "img/7.0c18786e.png";